import styled from 'styled-components';

import { base, screens, colors } from '../../../../styles';

export const MainPage = styled.div`
    max-width: ${base * 88}px;
`;

export const TitleCust = styled.div`
    font-size: 46px;
    font-weight: 300;
    color: #252525;
    span{
        margin-right: ${base - 6}px;
        &:last-child{
            color: ${colors.primary};;
        }
    }
    @media (max-width: ${screens.screen_xs_max}) {
      margin-bottom: 24
    }
`;

export const CustColumnsMain = styled.div`
    background: #FFFFFF;
    box-shadow: 1px 1px 32px rgba(0, 0, 0, 0.05);
    border-radius: ${base - 6}px;
    padding: 32px ${base * 3.75}px;
    p{
        line-height: 24px;
        font-size: 16px;
        color: #252525;
        margin-bottom: 20px;
    }
    @media (max-width: ${screens.screen_xs_max}) {
      padding: 24px;
    }
`;

export const NameColumns = styled.h1`
    font-size: 20px;
    color: #252525;
    margin-bottom: ${base * 2.25}px;
    margin-right: 12px;
    width: 30%;

    @media (max-width: ${screens.screen_xs_max}) {
      width: 100%;
    }

`;

export const CheckboxContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

export const ColumnsSection = styled.div`
    margin-bottom: 12px;
`;

export const CheckBoxWrapper = styled.div`
    margin-right: 12px;
    width: 30%;
    margin-bottom: 20px;
    @media (max-width: ${screens.screen_md_max}) {
        width: 45%;
    }
    @media (max-width: ${screens.screen_md_min}) {
        width: 50%;
    }
`;

export const HeaderTitle = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 0 32px 0;
    @media (max-width: ${screens.screen_xs_max}) {
      margin: 0 0 24px 0;
    }
`;

export const PopupCustTitle = styled.div`
    min-width: 324px;
    max-width: 594px;
    div{
        position: fixed;
        cursor: pointer;
        left: 50%;
        transform: translateX(-50%);
        bottom: -100px;
        transition: bottom .3s ease-in-out;
        bottom: 20px;
        border-radius: 8px;
        font-size: 20px;
    }
`;

export const SectionTitleWrapper = styled.div`
    display: flex;
    justify-content: start;
`;
